import { Flex, Text } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@morressier/alembic';
interface Props {
  title: string;
  subTitle: string;
  bgColor: string;
  icon?: IconProp;
}
const SubmissionLoader: React.FC<Props> = ({ title, subTitle, bgColor, icon=faSearch }) => {
  return (
    <>
      <Flex
        justifyContent="center"
        alignItems="center"
        backgroundColor={bgColor}
        borderRadius="small"
        height="112px"
      >
        <FontAwesomeIcon
          icon={icon}
          fontSize="42px"
        />
      </Flex>
      <Flex flexDirection="column" alignItems="center" marginTop={4}>
        <Text textStyle="headingGroup">{title}</Text>
        <Text>{subTitle}</Text>
        {title === 'Search Failed' && (
          <Button
            variant="secondary"
            onClick={() => window.location.reload()}
            marginTop={4}
          >
            Retry
          </Button>
        )}
      </Flex>
    </>
  );
};

export default SubmissionLoader;
